__turbopack_context__.v({
  "chip": "Chip-module-scss-module__V-gBga__chip",
  "primary": "Chip-module-scss-module__V-gBga__primary",
});
